<template>
  <header
      id="navbar"
      class="fixed w-full top-0 z-50 transition-all duration-300 bg-white/90 backdrop-blur-sm shadow-sm"
  >
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16 md:h-20">
        <div class="flex items-center">
            <img class="logoIcon" :src="require('@/assets/logo.png') "/>
            <span class="text-primary text-2xl font-bold _title">上海法烙科技有限公司</span>
        </div>

        <!-- 桌面导航 -->
        <nav class="hidden md:flex space-x-8">
          <a href="#home" class="text-neutral-700 hover:text-primary font-medium transition-colors duration-200">首页</a>
          <a href="#features" class="text-neutral-700 hover:text-primary font-medium transition-colors duration-200">功能</a>
          <a href="#services" class="text-neutral-700 hover:text-primary font-medium transition-colors duration-200">服务</a>
          <a href="#about" class="text-neutral-700 hover:text-primary font-medium transition-colors duration-200">关于</a>
          <a href="#contact" class="text-neutral-700 hover:text-primary font-medium transition-colors duration-200">联系我们</a>
          <a href="/privacy-policy.html" class="text-neutral-700 hover:text-primary font-medium transition-colors duration-200">隐私政策</a>
        </nav>

        <!-- 移动端菜单按钮 -->
        <div class="md:hidden">
          <button
              id="menu-toggle"
              class="text-neutral-700 hover:text-primary focus:outline-none"
              @click="toggleMobileMenu"
          >
            <i class="fa" :class="mobileMenuOpen ? 'fa-times text-xl' : 'fa-bars text-xl'"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- 移动端导航菜单 -->
    <div
        id="mobile-menu"
        class="hidden md:hidden bg-white border-t border-neutral-200 shadow-lg"
        :class="{ hidden: !mobileMenuOpen }"
    >
      <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <a
            href="#home"
            class="block px-3 py-2 rounded-md text-base font-medium text-neutral-700 hover:text-primary hover:bg-neutral-100 transition-colors duration-200"
            @click="toggleMobileMenu"
        >首页</a>
        <a
            href="#features"
            class="block px-3 py-2 rounded-md text-base font-medium text-neutral-700 hover:text-primary hover:bg-neutral-100 transition-colors duration-200"
            @click="toggleMobileMenu"
        >功能</a>
        <a
            href="#services"
            class="block px-3 py-2 rounded-md text-base font-medium text-neutral-700 hover:text-primary hover:bg-neutral-100 transition-colors duration-200"
            @click="toggleMobileMenu"
        >服务</a>
        <a
            href="#about"
            class="block px-3 py-2 rounded-md text-base font-medium text-neutral-700 hover:text-primary hover:bg-neutral-100 transition-colors duration-200"
            @click="toggleMobileMenu"
        >关于</a>
        <a
            href="#contact"
            class="block px-3 py-2 rounded-md text-base font-medium text-neutral-700 hover:text-primary hover:bg-neutral-100 transition-colors duration-200"
            @click="toggleMobileMenu"
        >联系我们</a>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    data() {
      return {
        mobileMenuOpen: false
      }
    },
    methods: {
      toggleMobileMenu() {
        this.mobileMenuOpen = !this.mobileMenuOpen;
      }
    },
    mounted() {
      // 导航栏滚动效果
      window.addEventListener('scroll', () => {
        const navbar = document.getElementById('navbar');
        if (window.scrollY > 50) {
          navbar.classList.add('shadow-md');
          navbar.classList.remove('bg-white/90');
          navbar.classList.add('bg-white');
        } else {
          navbar.classList.remove('shadow-md');
          navbar.classList.add('bg-white/90');
          navbar.classList.remove('bg-white');
        }
      });

      // 平滑滚动
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const targetId = this.getAttribute('href');
          const targetElement = document.querySelector(targetId);

          if (targetElement) {
            window.scrollTo({
              top: targetElement.offsetTop - 80,
              behavior: 'smooth'
            });
          }
        });
      });
    }
  }
</script>
<style>

  .logoIcon{
    height:50px;
  }
  ._title{
    font-size: 1.6rem;
    background: #000000;
    font-family: 'Inter', 'Helvetica Neue', sans-serif;
    font-weight: 900;
    background: linear-gradient(to bottom, #e34d4e, #cc512c);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    letter-spacing: -1px;
    margin-left:5px;
    margin-bottom:5px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
  }
</style>
